/**
 * Actions for <App /> container
 */
export const APP_TAB_CHANGE = 'APP_TAB_CHANGE';
export const APP_HISTORY_CHANGE = 'APP_HISTORY_CHANGE';

/**
 * Change search tag to given one
 *
 * @param {string} tab Tab to change
 * @returns {{}}
 */
export function changeTab(tab) {
    return {
        type: APP_TAB_CHANGE,
        tab,
    };
}

/**
 * Change history state
 * Used for browser history API
 *
 * @param {{}} payload History API
 * @returns {{}}
 */
export function changeHistory(payload) {
    return {
        type: APP_HISTORY_CHANGE,
        payload,
    };
}



// WEBPACK FOOTER //
// ./src/js/App/app.actions.js